import React, { CSSProperties } from 'react'
import { Classes } from '@blueprintjs/core'
import classnames from 'classnames'

export default function ColorSquare({
  skeleton,
  style,
}: {
  skeleton?: boolean
  style?: CSSProperties
}) {
  const className = classnames('w-4 h-4 flex-shrink-0 rounded shadow', {
    [Classes.SKELETON]: skeleton,
  })
  return <div {...{ style, className }} />
}
